import React from 'react';
import { InfoCardWidget } from '../../../../statisticsWidgets/statisticsWidgets';

export default ({ data, loading, title, children, comment }) => {
  return (
    <InfoCardWidget primaryColor="#fa748d" secondaryColor="#595959" icon="icon-cards" title={title}
                    data={data} loading={loading} comment={comment} >
      {children}
    </InfoCardWidget>
  );
};



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/widgets/guestCardActivities.js